import * as React from 'react';
import * as moment from 'moment';

interface Props {
  date: string;
  type: string;
  paymentSystem: string;
  sum: number;
}

const PaymentsTableBody = (props: Props) => {
  return(
    <div className='payment-table-body d-flex'>
      <div className=''>{moment(props.date).format('YYYY MMM DD')}</div>
      <div className=''>{moment(props.date).format('HH:mm:ss')}</div>
      <div className=''>{props.type}</div>
      <div className=''>{props.paymentSystem}</div>
      <div className=''>{props.sum}</div>
    </div>
  );
};

export default PaymentsTableBody;
